// extracted by mini-css-extract-plugin
export var canvas = "BrandCampaignHero-module--canvas--6d05a";
export var copy = "BrandCampaignHero-module--copy--f6f0b";
export var heading = "BrandCampaignHero-module--heading--d6ccc";
export var hero = "BrandCampaignHero-module--hero--53823";
export var heroWrapper = "BrandCampaignHero-module--hero-wrapper--eedfa";
export var modalClose = "BrandCampaignHero-module--modal-close--da485";
export var modalContent = "BrandCampaignHero-module--modal-content--b746b";
export var modalOverlay = "BrandCampaignHero-module--modal-overlay--71c8f";
export var video = "BrandCampaignHero-module--video--44043";